<template>

    <router-view></router-view>

</template>
<script>
export default {
	beforeRouteUpdate(to, from, next) {
		if(to.name == 'MeusCursos'){
			next({ name: 'MeusCursosLista' })
		}else{
			next()
		}
	},
	created() {
		if(this.$route.name == 'MeusCursos'){
			this.$router.push({ name: 'MeusCursosLista' })
		}
	}
}
</script>